import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "absolute version" }
const _hoisted_2 = { class: "version-value" }
const _hoisted_3 = {
  key: 0,
  class: "absolute"
}
const _hoisted_4 = ["src"]

import { User } from '@/models/user.model';
import { Actions, ShiftCMSState } from '@/store';
import { computed, onMounted, Ref, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import AppLanguage from './AppLanguage.vue';
import { UsersActions } from '@/stores/users.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppUser',
  setup(__props) {

const store = useStore<ShiftCMSState>();
const router = useRouter();
const user = computed<User | null>(() => store.state.loggedInUser);
const version = computed<string>(() => store.state.version);

/*
  This component show the logged in user, but also functions as a way to force
  The CMS to verify if the user is properly logged in
*/

onMounted(() => {
  store.dispatch(Actions.GetCurrentUser);
  store.dispatch(Actions.GetVersion);
});

const logout = () => {
  store.dispatch(Actions.Logout);
  router.push('/login');
};

const qrCode = ref<string>('');
const digits = ref<string>('');
const message = ref<string>('');

const enable2FA = async () => {
  const result = await store.dispatch(UsersActions.Enable2FA);

  qrCode.value = result.qrCodeDataUrl;
};

const verify2FA = async (isActive: Ref) => {
  const result = await store.dispatch(UsersActions.Verify2FA, digits.value);
  if (result.twoFactorEnabled) {
    isActive.value = false;
    store.dispatch(Actions.GetCurrentUser);
    message.value = '';
    store.dispatch(Actions.ShowNotification, {
      message: result.message,
      type: 'success',
    });
  } else {
    message.value = result.message;
  }
};

const disable2FA = async () => {
  const result = await store.dispatch(UsersActions.Disable2FA, user.value?.id);

  if (result.twoFactorDisabled) {
    store.dispatch(Actions.GetCurrentUser);
    message.value = '';
    store.dispatch(Actions.ShowNotification, {
      message: result.message,
      type: 'success',
    });
  } else {
    message.value = result.message;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppLanguage),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "Version", -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(version.value), 1)
    ]),
    (user.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "Logged in", -1)),
          _createVNode(_component_v_menu, null, {
            activator: _withCtx(({ props }) => [
              _createElementVNode("a", _mergeProps({
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
              }, props, { class: "user-name" }), _toDisplayString(user.value.firstName) + " " + _toDisplayString(user.value.lastName), 17)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        compact: "",
                        variant: "outlined",
                        outlined: "",
                        onClick: logout
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Log out ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      (!user.value.twoFactorEnabled)
                        ? (_openBlock(), _createBlock(_component_v_dialog, {
                            key: 0,
                            width: "auto"
                          }, {
                            activator: _withCtx(({ props: activatorProps }) => [
                              _createVNode(_component_v_btn, _mergeProps(activatorProps, {
                                class: "mt-2",
                                type: "button",
                                block: "",
                                color: "info",
                                onClick: enable2FA
                              }), {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode("Enable 2FA")
                                ])),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(({ isActive }) => [
                              _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Enable Two Factor Authentication", -1)),
                                      _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                                        _createElementVNode("strong", null, "Scan"),
                                        _createTextVNode(" the following QR code with your authenticator app. ")
                                      ], -1)),
                                      _createElementVNode("img", {
                                        src: qrCode.value,
                                        alt: "2FA QR code",
                                        style: {"margin":"0 auto","display":"block"}
                                      }, null, 8, _hoisted_4),
                                      _cache[8] || (_cache[8] = _createElementVNode("p", null, " Provide the 6 digit code and enable two factor authentication on your account. ", -1)),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                modelValue: digits.value,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((digits).value = $event)),
                                                label: "6 Digit Code"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                class: "mt-2",
                                                color: "success",
                                                type: "button",
                                                block: "",
                                                onClick: () => verify2FA(isActive)
                                              }, {
                                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                  _createTextVNode("Enable 2FA")
                                                ])),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (message.value)
                                        ? (_openBlock(), _createBlock(_component_v_alert, {
                                            key: 0,
                                            color: "warning"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(message.value), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "mt-2",
                            color: "warning",
                            type: "button",
                            block: "",
                            onClick: disable2FA
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("Disable 2FA")
                            ])),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  (message.value)
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, { color: "warning" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(message.value), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})